// extracted by mini-css-extract-plugin
module.exports = {"consent":"style_consent__JPrFG","box":"style_box__2UtgK","optional-tag":"style_optional-tag__2GCQB","required-mark":"style_required-mark__1HUH3"};